export default __webpack_public_path__ + "static/media/Screenshot (1176).d78b2718.png";